import styled from 'styled-components';
import EditSolid from '@simplywallst/ui-core/icons/EditSolid';

export const AddNoteSVG = styled(EditSolid)`
  &&& {
    opacity: 1;
  }
`;
